import { ReactComponent as LocationIcon } from './location.svg';

export default LocationIcon;
